<template>
	<el-menu class="left-menu" v-loading="menuLoading" element-loading-text="菜单加载中..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)" :default-active="$route.path" :collapse="isCollapse" :default-openeds="defaultOpeneds">
		<a href="/" class="a-title text-over">
			<span slot="title" class="title" :title="platformInfo.systemName">
			  {{platformInfo.systemName}}
			</span>
		</a>
		<div class="menu-box">
			<MenuTree :menuData="menuData"></MenuTree>
		</div>
		<el-empty class="empty" v-if="showEmpty && !isCollapse">
			<el-button size="small" type="primary" @click="getLeftMenu">重 试</el-button>
		</el-empty>
	</el-menu>
</template>

<script lang="ts" setup>
	import { ref, computed, watch } from 'vue'
	import { getMenu } from "@/request/api/auth"
	import { useModuleMapState } from '@/config/useMapState'
	import MenuTree from "@/components/com/MenuTree"
	
	const showEmpty = ref(false)
	const menuLoading = ref(false)
	const menuData = ref([])
	
	const defaultOpeneds = computed(() => {
		if(menuData.value.length){
			return menuData.value.map((v, i) => {
				return v.path
			})
		}else{
			return []
		}
	})
	const getLeftMenu = async () => {
		try {
			menuLoading.value = true
			let { code, data } = await getMenu()
			menuLoading.value = false
			if(code == 200){
				data = data.map((v) => {
					v.icon = v.icon.replace(/ fa-/, ' icon-')
					if(v.children && v.children.length){
						v.children = v.children.map((item:any) => {
							item.icon = item.icon.replace(/ fa-/, ' icon-')
							return item
						})
					}
					return v
				})
				menuData.value = data
				if (menuData.value.length === 0) showEmpty.value = true
				else showEmpty.value = false
			}else{
				showEmpty.value = true
			}
		} catch (error) {
		  showEmpty.value = true
		  setTimeout(() => { menuLoading.value = false }, 0)
		  console.log('getMenu fail', error)
		}
	}
	const init = () => {
		getLeftMenu()
	}
	const { token, platformInfo, isCollapse } = useModuleMapState('publicOptions', ['token', 'platformInfo', 'isCollapse'])
	if(token.value) init()
	watch(token, (val) => {
		if(val) init()
	})
</script>

<style scoped lang="scss">
	.left-menu{
		border: none;
		height: 100%;
		overflow: hidden;
		background: linear-gradient(-4deg, #5c4bd7, #5383ef);
		padding-top: 74px;
		--el-menu-bg-color: transparent;
		&:not(.el-menu--collapse){
			width: 240px;
		}
		&.el-menu--collapse{
			:deep(.textspan){
				display: none;
			}
		}
		:deep(.el-menu-item),:deep(.el-sub-menu__title){
			--el-menu-text-color: #fff;
			--el-menu-item-font-size: 18px;
			--el-menu-hover-bg-color: rgba(255,255,255,.3);
		}
		.empty {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
		:deep(.el-menu){
			.el-menu-item,.el-sub-menu__title{
				--el-menu-item-font-size: 14px;
			}
		}
		:deep(.el-menu-item){
			align-items: center;
			&.is-active{
				color: #fff;
				background-color: rgba(255,255,255,.3);
			}
		}
		:deep(.iconfont){
			display: inline-block;
			vertical-align: middle;
			width: 20px;
			height: 20px;
			line-height: 20px;
			font-size: 19px;
			margin-top: 2px;
			margin-right: 17px;
			&.icon-role{
				font-size: 22px;
			}
			&.icon-applet{
				font-size: 24px;
			}
		}
		
		::-webkit-scrollbar {
		  width: 0;
		}
	}
	.a-title{
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		display: block;
		line-height: 74px;
		height: 74px;
		color: #fff;
		text-align: center;
		.title{
			font-size: 24px;
			color: #fff;
		}
	}
	.menu-box{
		height: 100%;
		overflow: auto;
	}
</style>
